
import { Button, Divider, FormControl, Grid, TextField } from '@mui/material'

import { CustomAutocomplete } from 'common'

import { ModalFormCash } from './ModalFormCash'
import { ModalFormDeposit } from './ModalFormDeposit'

export const ModalDeposit = ({useFetchInit}) =>{

    const {
        defaultData,
        globalStates,
        Forms,
        Actions
    } = useFetchInit

    const { modalOpeningMode} = globalStates

    const { handleClickCloseModal, handleChangeTypeCurrency, handleChangeExchangeRate, handleChangeAmount, onSubmitFormDeposits } = Actions

    const { FormDeposit } = Forms
    const { formState, onInputChange, onSelectSearchChange } = FormDeposit

    return(
        <form onSubmit={onSubmitFormDeposits}>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth> 
                        <label htmlFor="deposito_fecha">* Fecha</label>
                        <TextField
                            id='deposito_fecha'
                            name='deposito_fecha'
                            value={ formState.deposito_fecha }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Fecha'
                            hiddenLabel
                            type='date'
                            variant={(modalOpeningMode === 'READONLY' || formState.movimiento_tipo === 'EFECTIVO') ? 'filled' : 'outlined' }
                            InputProps={{
                                readOnly: (modalOpeningMode === 'READONLY' || formState.movimiento_tipo === 'EFECTIVO') ? true : false 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label htmlFor="movimiento_tipo">* Tipo</label>
                        <CustomAutocomplete 
                            customId="movimiento_tipo"
                            customName="movimiento_tipo"
                            customValue={formState.movimiento_tipo}
                            customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'movimiento_tipo', value: value.value }})}
                            customPlaceholder='Seleccionar casa'
                            customOptions={
                                defaultData.optionsTypePayment.map(({ value, label }) => ({
                                    value: value,
                                    name: label
                                }))
                            }
                            customDisableClearable={true}
                            customDisabled={(modalOpeningMode === 'READONLY') ? true : false}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <FormControl fullWidth>
                        <label htmlFor="deposito_monto">* Monto</label>
                        <TextField
                            id='deposito_monto'
                            name='deposito_monto'
                            value={ formState.deposito_monto_mask }
                            onChange={ handleChangeAmount }
                            size='small'
                            type='text'
                            variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                            hiddenLabel
                            InputProps={{
                                readOnly: (modalOpeningMode === 'READONLY') ? true : false
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <FormControl fullWidth>
                        <label htmlFor="deposito_moneda">* Moneda</label>
                        <CustomAutocomplete 
                            customId="deposito_moneda"
                            customName="deposito_moneda"
                            customValue={formState.deposito_moneda}
                            customOnChange={(target, value) => handleChangeTypeCurrency({ target: { name: 'deposito_moneda', value: value.value }})}
                            customPlaceholder='Seleccionar moneda'
                            customOptions={
                                defaultData.optionsTypeMoneda.map(({ value, label }) => ({
                                    value: value,
                                    name: label
                                }))
                            }
                            customDisableClearable={true}
                            customDisabled={(modalOpeningMode === 'READONLY') ? true : false}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <FormControl fullWidth>
                        <label htmlFor="deposito_tipo_cambio">* Tipo de Cambio</label>
                        <TextField
                            id='deposito_tipo_cambio'
                            name='deposito_tipo_cambio'
                            value={ formState.deposito_tipo_cambio }
                            onChange={ handleChangeExchangeRate }
                            placeholder='Tipo de Cambio'
                            size='small'
                            hiddenLabel     
                            type='number'
                            variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                            InputProps={{
                                readOnly: (modalOpeningMode === 'READONLY') ? true : false
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label htmlFor="deposito_quetzales">* Total en Quetzales</label>
                        <TextField
                            id='deposito_quetzales'
                            name='deposito_quetzales'
                            value={ formState.deposito_quetzales }
                            onChange={ onInputChange }
                            placeholder='Total Quetzales'
                            size='small'
                            type='number'
                            hiddenLabel
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label htmlFor="deposito_dolares">* Total en Dolares</label>
                        <TextField
                            id='deposito_dolares'
                            name='deposito_dolares'
                            value={ formState.deposito_dolares }
                            onChange={ onInputChange }
                            placeholder='Total en Dolares'
                            size='small'
                            type='number'
                            variant="filled"
                            hiddenLabel
                            InputProps={{
                                readOnly: true
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Divider />


            {(formState.movimiento_tipo==='EFECTIVO')&&(
                <ModalFormCash
                    useFetchInit = {useFetchInit}
                />
            )}

            {(formState.movimiento_tipo==='DEPOSITO')&&(
                <ModalFormDeposit
                    useFetchInit = {useFetchInit}
                />
            )}
            <div className="border-bottom border-secondary"></div>
            <div className="pt-4"></div>
            <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>                
                <Grid item xs={12}>
                    <div className="text-center">
                        {(modalOpeningMode==='EDITABLE') && (
                            <Button
                                variant="contained"
                                type="submit"
                                style={{background: "#4b4b4c"}}
                            >
                                <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                            </Button>
                        )}
                        &nbsp; &nbsp;
                        <Button 
                            variant="contained"
                            type="button" 
                            onClick={() => handleClickCloseModal(false, 'EDIT')} 
                            style={{background: "#ef8157"}}
                        >
                            <i className="fa-regular fa-circle-left"></i> &nbsp; Volver
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </form>
    )
}